module.exports = __webpack_public_path__ + "media/images/brand/favicon-03-c91447ed678f6ea46b19491b35a9fd10.png";